export default "__VITE_ASSET__DNGbLv_p__"